import { render, staticRenderFns } from "./PharmacistsDialog.vue?vue&type=template&id=d079a83e&"
import script from "./PharmacistsDialog.vue?vue&type=script&lang=js&"
export * from "./PharmacistsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports